<template>
  <div rel="upload">
    <div v-if="isEditing">
      <el-form-item prop="title" label="题目">
        <wjQuillEditor
          :content="tempQuesData.title"
          :config="config"
          @onChange="handleEditorChange"
        ></wjQuillEditor>
      </el-form-item>
      <el-form-item label="备注">
        <el-input class="editor-input" v-model="tempQuesData.description"></el-input>
      </el-form-item>
    </div>
    <div v-else>
      <div class="ques-title">
        {{ ques.index + 1 }}.
        <p style="display: inline-block;" v-html="ques.title"></p>
        <i v-if="ques.required" class="required-icon">*</i>
      </div>
      <p class="ques-desc">{{ ques.description }}</p>
      <el-upload class="upload-demo" drag action multiple size="small">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          仅支持单文件
          <em>点击上传</em>
        </div>
        <div
          class="el-upload__tip"
          slot="tip"
        >可上传gif, png, jpg, jpeg, bmp, doc, docx, pdf, xls, xlsx, ppt, pptx, txt, zip, gzip, rar件，且不超过50M</div>
      </el-upload>
    </div>
  </div>
</template>
<script>
import wjQuillEditor from "./wj-quill-editor.vue";
export default {
  name: "upload",
  props: ["isEditing", "tempQuesData", "ques", "config"],
  components: {
    wjQuillEditor
  },
  data() {
    return {
      questionType: "upload"
    };
  },
  methods: {
    handleEditorChange(data) {
      this.tempQuesData.title = data;
    }
  }
};
</script>
<style lang="scss">
div[rel="upload"] {
  .upload-demo {
    .el-upload--text {
      width: 100%;
      .el-upload-dragger {
        width: 100%;
        .upload-content {
          width: 200px;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue